import React from 'react';
import PropTypes from 'prop-types';
import HubResultCard from '../../../02_molecules/HubSearch/HubResultCard';

import styles from './index.module.scss';

const BBHubResources = ({ resources, heading = null, variant = 'vertical', uuid = null }) => (
  <div
    className={`bb bb-hub-resources analytics-bb-hub-resources-${variant} ${styles['bb-hub-resources']}`}
    id={uuid}
    // Hide BBSidebarTableOfContents when it is nearby the element.
    data-toc={variant === 'horizontal' ? 'hide' : 'show'}
  >
    <div className={variant === 'horizontal' ? `${styles['horizontal']} container` : 'container'}>
      {heading && <h2 className={styles['bb-hub-resources-heading']}>{heading}</h2>}
      {resources && (
        <ul className={styles['bb-hub-resources-wrapper']}>
          {resources.map((item, index) => (
            <li key={index}>
              <HubResultCard
                title={item.title}
                type={item.type}
                resourceType={item.resourceType}
                timestamp={item.timestamp}
                description={item.description}
                image={item.image}
                link={item.link}
                featured={item.featured}
                variant={variant === 'horizontal' ? 'tall' : 'wide'}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

BBHubResources.propTypes = {
  heading: PropTypes.string,
  variant: PropTypes.oneOf(['vertical', 'horizontal']),
  resources: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
    }),
  ).isRequired,
  uuid: PropTypes.string,
};

export default BBHubResources;
